import { render, staticRenderFns } from "./index.vue?vue&type=template&id=88ed34d2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=88ed34d2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ed34d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88ed34d2')) {
      api.createRecord('88ed34d2', component.options)
    } else {
      api.reload('88ed34d2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=88ed34d2&scoped=true", function () {
      api.rerender('88ed34d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/components/custom-svg-icon/index.vue"
export default component.exports